import { Zap, Leaf, ShieldCheck, BadgeCheck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { WHY_US, IMAGES } from "../lib/data";

const ICONS = { Zap, Leaf, ShieldCheck, BadgeCheck };

export const WhyUs = () => (
  <section id="apropos" data-testid="why-us-section" className="py-20 md:py-28 bg-sky-50/50 overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <Overline>Pourquoi nous choisir</Overline>
            <h2 className="mt-4 font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
              La propreté, élevée au rang d'engagement
            </h2>
          </Reveal>

          <div className="mt-10 space-y-8">
            {WHY_US.map((w, i) => {
              const Icon = ICONS[w.icon];
              return (
                <Reveal key={w.num} delay={i * 0.1}>
                  <div data-testid={`why-us-chapter-${w.num}`} className="flex gap-6 items-start">
                    <span className="font-heading text-4xl sm:text-5xl font-extrabold text-sky-200 leading-none shrink-0 w-16">
                      {w.num}
                    </span>
                    <div>
                      <h3 className="flex items-center gap-2 font-heading text-lg font-semibold text-slate-900">
                        <Icon size={18} className="text-emerald-500" /> {w.title}
                      </h3>
                      <p className="mt-1.5 text-sm sm:text-base text-slate-600 leading-relaxed">{w.desc}</p>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>

        <Reveal delay={0.2} className="relative">
          <div className="rounded-[2rem] overflow-hidden shadow-2xl shadow-sky-900/15 border-4 border-white">
            <img
              src={IMAGES.veranda}
              alt="Véranda lumineuse nettoyée par WM Clean"
              data-testid="why-us-image"
              className="w-full h-[420px] lg:h-[560px] object-cover"
            />
          </div>
          <div className="absolute -bottom-5 right-6 rounded-2xl bg-emerald-500 text-white px-6 py-4 shadow-xl shadow-emerald-600/30">
            <p className="font-heading text-2xl font-extrabold leading-none">100 %</p>
            <p className="text-xs font-medium mt-1 text-emerald-50">Satisfait ou refait</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
